
export const screenSize = {
    desktop: "(min-width: 1200px)", 
    normalSizeTable: "(min-width: 1200px)",
    tablet: "(min-width: 600px)" 
};
